<template lang="pug">
.cadastro-form-select
  select.cadastro-form-select__control(
    :class="{ 'is-placeholder': !selectValue }"
    :value="selectValue"
    :disabled="disabled"
    @change="$emit('input', $event.target.value)"
    @focus="$emit('focus')"
  )
    option(value="" hidden) {{ placeholder }}
    option(
      v-for="option in options"
      :key="optionKey(option)"
      :value="optionValue(option)"
    ) {{ optionLabel(option) }}
  img.cadastro-form-select__chevron(
    src="@/assets/icons/cadastro/chevron-down.svg"
    alt=""
  )
</template>

<script>
export default {
  name: 'CadastroFormSelect',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: 'Selecione'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    labelKey: {
      type: String,
      default: 'label'
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    primitiveOptions: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    selectValue () {
      return this.value == null ? '' : this.value
    }
  },
  methods: {
    optionKey (option) {
      return this.primitiveOptions ? option : option[this.valueKey]
    },
    optionValue (option) {
      return this.primitiveOptions ? option : option[this.valueKey]
    },
    optionLabel (option) {
      return this.primitiveOptions ? option : option[this.labelKey]
    }
  }
}
</script>

<style lang="scss" scoped>
.cadastro-form-select {
  position: relative;
  width: 100%;
}

.cadastro-form-select__control {
  appearance: none;
  background: #ffffff;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  color: #141414;
  cursor: pointer;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 14px;
  height: 40px;
  line-height: 1.43;
  padding: 0 36px 0 12px;
  width: 100%;

  &.is-placeholder {
    color: #8a8a8a;
  }

  &:disabled {
    color: #8a8a8a;
    cursor: not-allowed;
    opacity: 0.7;
  }

  &:focus {
    border-color: #1e174e;
    outline: none;
  }
}

.cadastro-form-select__chevron {
  height: 16px;
  pointer-events: none;
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
}
</style>
